import { render, staticRenderFns } from "./ImmediatePaymentForm.vue?vue&type=template&id=062b4800&scoped=true&"
import script from "./ImmediatePaymentForm.vue?vue&type=script&lang=js&"
export * from "./ImmediatePaymentForm.vue?vue&type=script&lang=js&"
import style0 from "./ImmediatePaymentForm.vue?vue&type=style&index=0&id=062b4800&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062b4800",
  null
  
)

export default component.exports